// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aA1I","placeholdersHeader":"styles_placeholdersHeader__1uUUy","editorStyle":"styles_editorStyle__vNPHI","placeholdersBox":"styles_placeholdersBox__UD8Uf"};